<div class="shared-title-checkbox-options" id="shared-title-checkbox-options">
  <app-text
    [textStyleType]="checkboxLabelFontType"
    id="shared-title-checkbox-text-content"
    >{{ title }}</app-text
  >
  <ng-container *ngFor="let item of optionsList; let i = index">
    <app-checkbox
      class="checkbox"
      [checkboxData]="item.name"
      [checkboxId]="item.id.toString()!"
      [defaultChecked]="item.checked!"
      [isDisabled]="isDisabled"
      [fontType]="'body1'"
      (checkboxCheck)="clickCheckbox($event)"
      [id]="'shared-checkbox-' + i"
    ></app-checkbox>
  </ng-container>
</div>
